import React from 'react'
import { AppSvg, FormattedHTMLMessage, NavMenuItem, newIcons } from '@web/walter-ui-kit'
import { useIntl } from 'react-intl'
import { useCommonCMSConfig } from '~api'
import { globalLang } from '~globalLang'

function ProTradeButton() {
    const intl = useIntl()
    const { features = {} } = useCommonCMSConfig().data ?? {}

    if (!features.showProTrade) {
        return null
    }

    return (
        <NavMenuItem
            icon={<AppSvg path="new-icons" svgName={newIcons.ic24Trading} size={24} />}
            type="anchor"
            href={intl.formatMessage(globalLang.proLinkHref)}
            dataPointer="pro_link"
        >
            <FormattedHTMLMessage
                {...globalLang.proLinkText}
                values={{ brokerName: intl.formatMessage(globalLang.brokerName) }}
            />
        </NavMenuItem>
    )
}

export default ProTradeButton
